<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('products')">Prodotti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Crea
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/3" label="SKU" />
          <text-input v-model="form.ean_produttore" :error="form.errors.ean_produttore" class="pr-6 pb-8 w-full lg:w-1/3" label="EAN produttore" />
          <text-input v-model="form.cod_art_produttore" :error="form.errors.cod_art_produttore" class="pr-6 pb-8 w-full lg:w-1/3" label="Codice articolo produttore" />
          <text-input v-model="form.brand" :error="form.errors.brand" class="pr-6 pb-8 w-full lg:w-1/3" label="Brand" />
          <text-input v-model="form.categoria" :error="form.errors.categoria" class="pr-6 pb-8 w-full lg:w-1/3" label="Categoria" />
          <text-input v-model="form.stagione" :error="form.errors.stagione" class="pr-6 pb-8 w-full lg:w-1/3" label="Stagione" />
          <text-input v-model="form.genere" :error="form.errors.genere" class="pr-6 pb-8 w-full lg:w-1/3" label="Genere" />
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.taglia" :error="form.errors.taglia" class="pr-6 pb-8 w-full lg:w-1/3" label="Taglia" />
          <text-input v-model="form.colore" :error="form.errors.colore" class="pr-6 pb-8 w-full lg:w-1/3" label="Colore" />
          <!-- <text-input v-model="form.prezzo_acquisto" :error="form.errors.prezzo_acquisto" class="pr-6 pb-8 w-full lg:w-1/2" label="Prezzo di acquisto" /> -->
          <text-input v-model="form.prezzo_unitario" :error="form.errors.prezzo_unitario" class="pr-6 pb-8 w-full lg:w-1/3" label="Prezzo unitario" />
          <!-- <text-input v-model="form.quantita" :error="form.errors.quantita" class="pr-6 pb-8 w-full lg:w-1/2" label="Quantità" /> -->

          <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crea Prodotto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Prodotto' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    batches: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: null,
        ean_produttore: null,
        cod_art_produttore: null,
        brand: null,
        categoria: null,
        stagione: null,
        genere: null,
        name: null,
        taglia: null,
        colore: null,
        // prezzo_acquisto: null,
        prezzo_unitario: null,
        // quantita: null,
        // batch_id: null,
      }),
    }
  },
  methods: {
    store() {
      if (navigator.onLine) {
        this.form.post(this.route('products.store'))
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
  },
}
</script>
